import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";
import noAvatar from "../../../assets/images/stubs/avatar.svg";
import getHost, { link, url } from "../../../store/host-store";
import PaginationPattern from "../../../UI/PaginationPattern";
import FormModal from "../../../UI/Modal/FormModal/FormModal";
import { EyeIcon } from "../../../components/icons/EyeIcon";
import Loader from "../../../components/loader/Loader";
import DateRangePickerExample from "./CalendarFromTo";
import { token } from "../../../App";
import style from "../promocode/style.module.sass";
import {useForm} from "react-hook-form";
import ChangeModeratorRole from "./ChangeModeratorRole";
import {useDispatch, useSelector} from "react-redux";
import {moderatorsAction} from "../../../store/redux";
import {useGetPricesPartnerQuery} from "../../../store/redux/queries/partnerProgram/partner-program-prices";

const Statistic = () => {
    const adModeratorPage = window.location.href.indexOf('/ad_statistic') > -1;
    const moderator = useSelector(state => state.moderators.whichModerator);
    const dispatch = useDispatch();
    const [page, setPage] = useState(null);
    const [modalModerator, setModalModerator] = useState(false);
    const [dataUsers, setDataUsers] = useState([]);
    const [pageCount, setPageCount] = useState(0); //количество страниц с бэка для пагинации
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [openModalPrice, setOpenModalPrice] = useState(false);
    const {register, handleSubmit} = useForm();
    const {data: dataSum} = useGetPricesPartnerQuery({id: 3})
    //необходимо для передачи параметра страницы в url
    const navigate = useNavigate();
    //получаем параметры текущей страницы
    const params = new URLSearchParams(window.location.search);

    useEffect(() => {
        //проверяем попали ли на страницу по кнопке назад, и есть ли в параметрах ?page=
        const isPageParam = params.get("page");
        //если есть (!null) то переопределяем
        if (isPageParam !== null) {
            setPage(Number(isPageParam));
        } else {
            setPage(1);
        }
    }, [params]);

    useEffect(() => {
        if(adModeratorPage){
            dispatch(moderatorsAction.changeModerator("ad_moderator"))
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);

        if (page !== null) {
            fetch(
                getHost({
                    controller: "account",
                    expand: "user",
                    filter: {
                        role: moderator,
                    },
                    pagination: {
                        pageSize: 30,
                        page,
                    },
                }),
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: token,
                    },
                }
            )
                .then((res) => res.json().then((data) => ({ data, headers: res.headers })))
                .then((result) => {
                    setLoading(false);
                    if (result.data.success) {
                        setDataUsers(result.data.data);
                        setPageCount(Number(result.headers.get("X-Pagination-Page-Count")));
                    }
                });
        }
    }, [page, moderator]);

    const setChange = (value) => {
        setPage(value);
        //передаем значение страницы в url
        navigate(`?page=${value}`);
    };

    //поиск календарь
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const getStatistic = () => {
        fetch(
            `${link}/user/statistics-uploading?dateStart=${moment(startDate).format("YYYY-MM-DD")}&dateEnd=${moment(
                endDate
            ).format("YYYY-MM-DD")}`,
            {
                headers: {
                    Accept: "application/json",
                    Authorization: token,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                window.open(result.data.link);
                window.close()
            })
            .catch((e) => console.log(e));
    };

    const onResetBalance = (e) => {
        e.preventDefault();

        fetch(
            getHost({
                controller: "user",
                action: "reset-balance",
            }),
            {
                headers: {
                    Accept: "application/json",
                    Authorization: token,
                },
                method: "PUT",
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result.success) {
                    setOpenModal(false);
                }
            })
            .catch((e) => console.log(e));
    };


    const changeInfoModerator = async (data2) => {
        if(data2.schedule.length > 0){
            fetch(`${link}/settings/1`, {
                method: 'PUT',
                headers: {
                    Accept: "application/json",
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({text: data2?.schedule})
            })
                .then(res => res.json())
        }
        if(data2.date.length > 0){
            fetch(`${link}/settings/2`, {
                method: 'PUT',
                headers: {
                    Accept: "application/json",
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({text: data2?.date})
            })
                .then(res => res.json())
        }
        await setModalModerator(false)
    }

    const changePriceModerator = async (data) => {
        fetch(`${link}/settings/3`, {
            method: 'PUT',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
                Authorization: token,
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
        await setOpenModalPrice(false)
    }

    return (
        <div className="admin__layout admin__statistic">
            {loading ? (
                <Loader />
            ) : (
                <>
                    {openModal && (
                        <FormModal
                            title="Вы уверены?"
                            text="Сбросить баланс всех модераторов?"
                            button="Подтвердить"
                            fn={onResetBalance}
                            isOpenModal={setOpenModal}
                        />
                    )}
                    {openModalPrice && (
                        <FormModal
                            title="Изменить сумму за модерацию"
                            button="Подтвердить"
                            fn={handleSubmit(changePriceModerator)}
                            isOpenModal={setOpenModalPrice}
                        >
                            <input {...register("text")} defaultValue={dataSum?.data.text} type="number"/>
                        </FormModal>
                    )}
                    {modalModerator && (
                        <FormModal
                            title="Изменить дату выплаты"
                            button="Сохранить"
                            fn={handleSubmit(changeInfoModerator)}
                            isOpenModal={setModalModerator}
                        >
                            <div className={style.inputList}>
                                <input {...register("schedule")} placeholder="График вывода денег" />
                                <input {...register("date")} placeholder="Дата ближайшего вывода денег" />
                                {/*{error.field && <span>{error.message}</span>}*/}
                            </div>
                        </FormModal>
                    )}

                    <div className="admin__statistic_top">
                        <h3>Статистика работы модераторов</h3>
                        <div className="admin__statistic_navigation_calendar">
                            <DateRangePickerExample
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                            />
                            <button type="button" className="admin__btn-blue" onClick={getStatistic}>
                                Выгрузка по дате
                            </button>
                        </div>
                    </div>
                    <ChangeModeratorRole />
                    <div className={"admin__statistic_top_btn"}>
                        <button type="button" className="admin__btn-transparent" onClick={() => setModalModerator(true)}>
                            Изменить дату выплаты
                        </button>
                        <button type="button" className="admin__btn-transparent" onClick={() => setOpenModalPrice(true)}>
                            Изменить сумму за модерацию
                        </button>
                        <button type="button" className="admin__btn-transparent" onClick={() => setOpenModal(true)}>
                            Сброс баланса
                        </button>
                    </div>

                    {dataUsers.length > 0 ? (
                        <>
                            <div className="admin__list-titles admin__list-titles_statistic">
                                <p>ID</p>
                                <p>Фото</p>
                                <p>Имя</p>
                                <p>E-mail</p>
                                <p>Обработано объектов</p>
                            </div>
                            <div>
                                {dataUsers.map((el) => (
                                    <div className="admin__content-card admin__content-card_statistic" key={el.id}>
                                        <span>#{el.user.id}</span>
                                        {el.user.avatar === null ? (
                                            <img src={noAvatar} alt="avatar" />
                                        ) : el.user?.webpFilename ? (
                                            <img src={url + el.user.webpFilename} alt="avatar" />
                                        ) : (
                                            <img src={url + el.user.avatar} alt="avatar" />
                                        )}
                                        <p>{el.user.name}</p>
                                        <p>{el.user.email}</p>
                                        <p>{el.user.statistics?.objectsTotal}</p>
                                        <div className="admin__content-card-icons">
                                            <NavLink to={`${el.user.id}`}>
                                                <EyeIcon />
                                            </NavLink>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {pageCount > 1 && (
                                <PaginationPattern
                                    setChange={(e, value) => setChange(value)}
                                    pageCount={pageCount}
                                    page={page}
                                />
                            )}
                        </>
                    ) : (
                        <>Нет пользователей с ролью "модератор"</>
                    )}
                </>
            )}
        </div>
    );
};

export default Statistic;
